import React, { CSSProperties, useCallback, useEffect, useRef, useState } from "react";
import { debounce } from "underscore";
import * as RC from '@uiw/react-color';
import hexToReactColorResult from "../util/hex-to-color";
import EyeDropper from "./eyedropper";

interface IColorPickerProps {
	/** color is a [hex value, opacity], including the hash on the hex */
	colorHex: string;
	onChangeComplete?: (color: RC.ColorResult) => void;
	pickerClassname?: string;
	width?: number;
	opacity?: number;
}


export default function PickerBody({
	colorHex,
	onChangeComplete,
	pickerClassname = '',
	width = 270,
	opacity = 1
}: IColorPickerProps) {
	const [pickedColor, setPickedColor] = useState<RC.ColorResult>(hexToReactColorResult(colorHex));

	useEffect(() => {
		setPickedColor(hexToReactColorResult(colorHex));
	}, [colorHex]);

	const debounced = useRef(debounce((color: RC.ColorResult) => {
		onChangeComplete?.(color);
	}, 100)).current;

	const handleColorChange = useCallback((color: RC.ColorResult) => (callDebounce: boolean) => {
		setPickedColor(color);
		if (callDebounce) {
			debounced(color);
		}
	}, []);

	if (!pickedColor) return null;
	return (
		<div 
			className={`customized-color-picker ${pickerClassname}`}
			style={{
				'--width-of-picker': `${270}px`,
				'--height-of-picker': `${247}px`
			} as CSSProperties}
		>
			<RC.Saturation
				className="w-color-saturation"
				style={{width: '100%',height:'119px',borderRadius:'8px'}}
				hsva={pickedColor.hsva}
				onChange={(HSVA) => handleColorChange?.(RC.color(HSVA))(true)}
			/>
			<div className="flex-center w-hue-container">
				<EyeDropper
					size={16}
					onSelectColor={hex => {
						const colorResult: RC.ColorResult = hexToReactColorResult(hex, pickedColor.rgba.a ?? 1);
						handleColorChange?.(colorResult)(true);
					}}
				/>
				<RC.Hue
					hue={pickedColor.hsla.h}
					className=""
					style={{height:'12px'}}
					defaultValue={pickedColor.hsla.h}
					onChange={(hue) => handleColorChange?.(RC.color({...pickedColor.hsva, h: hue.h}))(true)}
					
				/>
				<RC.Swatch
					className="w-color-swatch"
					color={pickedColor.hex}
					style={{backgroundColor: pickedColor.hex}}
				/>
			</div>
			<div className="flex-center">
				<RC.EditableInput
					className='w-color-editable-input'
					value={pickedColor.hex}
					label="HEX"
					style={{
						marginRight:'10px',
						minWidth:'93px',
						maxWidth:'93px'
					}}
					onChange={(e, val) => handleColorChange(hexToReactColorResult(`${val}`))(true)}
				/>
				<RC.EditableInputRGBA 
					hsva={pickedColor.hsva}
					aProps={false}
					onChange={(c) => handleColorChange(c)(true)}
				/>
			</div>
		</div>
	);
};